import { render, staticRenderFns } from "./featured-product.vue?vue&type=template&id=6424302e&"
import script from "./featured-product.vue?vue&type=script&lang=js&"
export * from "./featured-product.vue?vue&type=script&lang=js&"
import style0 from "./featured-product.vue?vue&type=style&index=0&id=6424302e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports